// @flow

import * as React from "react";
import cx from "classnames";

import styles from "./Preloader.scss";

type PreloaderProps = {
  inverted: boolean,
  size: "large" | "medium" | "small",
  customStyles?: string
};

const Preloader = ({ inverted, size, customStyles }: PreloaderProps) => (
  <div
    className={cx(
      styles.preloader,
      {
        [styles["preloader--inverted"]]: inverted,
        [styles[`preloader--${size}`]]: size !== "medium"
      },
      customStyles
    )}
    data-testid="preloader"
  />
);

Preloader.defaultProps = {
  inverted: false,
  size: "medium"
};

export default Preloader;
